import { NgModule } from "@angular/core";
import { IonicPageModule } from "ionic-angular";
import { ResellerOrderListPage } from "./reseller-order-list";

@NgModule({
  declarations: [ResellerOrderListPage],
  imports: [IonicPageModule.forChild(ResellerOrderListPage)],
})
export class ResellerOrderListPageModule {}



// WEBPACK FOOTER //
// ./src/pages/reseller-order-list/reseller-order-list.module.ts